export default __webpack_public_path__ + "static/footer_wave-a9860dc5ffd025154dac9731454d7683.svg";